// extracted by mini-css-extract-plugin
export default {"wrapper":"TopHeader_wrapper__4OAw5","img":"TopHeader_img__5QfvU"};